// extracted by mini-css-extract-plugin
export default {"child":"MetaTag_child__NbESk","background":"MetaTag_background__8-PSQ","label":"MetaTag_label__kS5mM","selected":"MetaTag_selected__K9gse","interactive":"MetaTag_interactive__FZ15k"};